import { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import ApiService from "../../../services/api";

const CategoryEdit = () => {
  const { idCategory } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({});

  const fetchCategorie = async () => {
    try {
      const category = await ApiService.getCategoriesID(idCategory);
      setFormData({
        name: category.name,
        name_eng: category.name_eng,
        type: category.type,
      });
      setLoading(false);
    } catch (error) {
      navigate("/admin/categoryData");
    }
  };
  useEffect(() => {
    fetchCategorie();
  }, [idCategory]);

  // Gestione dei cambiamenti nel form
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Gestione dell'invio del form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.name === "" ||
      formData.name_eng === "" ||
      formData.type === "/"
    ) {
      setErrors(true);
      return;
    } else {
      setErrors(false);
    }

    try {
      await ApiService.updateCategory(idCategory, formData);
      window.location.replace("/admin/categoryList");
    } catch (error) {
      console.error("Errore durante l'aggiornamento dell'articolo:", error);
    }
  };
  if (Loading) return;
  return (
    <Container fluid className="pt-4 text_data_admin ">
      <div>
      <nav aria-label="breadcrumb">
          <ol className="breadcrumb pb-5">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item" aria-current="page">
              <Link to="/admin/categoryList">Categorie</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Modifica Categorie
            </li>
          </ol>
        </nav>
      </div>
      <h1 className="fs-2 text_data_admin form-title">Modifica Categoria</h1>
      <Row>
        <Col lg="6">
          <label htmlFor="type" className="form-label">
            Categoria *
          </label>
          <select
            value={formData.type}
            className="form-select"
            id="type"
            name="type"
            onChange={handleChange}
          >
            <option >news</option>
            <option >music</option>
            <option >lable</option>
            <option >about</option>
            <option >bio</option>
            <option >credits</option>
            <option >gallery</option>
          </select>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col lg="6">
          <label htmlFor="name" className="form-label">
            Nome *
          </label>
          <input
            value={formData.name}
            onChange={handleChange}
            type="text"
            className="form-control"
            id="name"
            placeholder="Nome"
            name="name"
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col lg="6">
          <label htmlFor="name_eng" className="form-label">
            Nome Inglese *
          </label>
          <input
            value={formData.name_eng}
            onChange={handleChange}
            type="text"
            className="form-control"
            id="name_eng"
            placeholder="Nome Inglese"
            name="name_eng"
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          {errors && (
            <span style={{ color: "red" }}>Compila i campi obbligatori</span>
          )}
        </Col>
      </Row>
      <Row>
      <Col className="py-5 text-start">
        <Button
         className="btn btn-black-gradient text-white"
         onClick={handleSubmit}
         variant="none"
         style={{width: '300px'}}
        >
          Modifica
        </Button>
      </Col>
      </Row>
    </Container>
  );
};
export default CategoryEdit;
